import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { initLogging } from './logging';


if (environment.name !== 'development' || environment.forceLogging) {
  initLogging();
}

if (environment.name !== 'development') {
  enableProdMode();
}

svg4everybody();

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.log(err));

